import { queryOptions, useQuery } from '@tanstack/react-query';

import type { BelgianVatNumber } from './types';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { peppolInformationSchema } from './schemas';

const peppolIdQueryOptions = (vatNumber: BelgianVatNumber | null) =>
  queryOptions({
    queryKey: QueryKeys.clients.peppolId(vatNumber ?? ''),
    queryFn: () => {
      return fetchJson(`/clients/peppol-id/${vatNumber}`, {
        schema: peppolInformationSchema,
      });
    },
    staleTime: 10 * 60 * 1000,
    enabled: vatNumber !== null,
  });

export const useClientPeppolId = (vatNumber: BelgianVatNumber | null) => {
  return useQuery(peppolIdQueryOptions(vatNumber));
};
